import React, { useEffect, useState } from "react";
import ViewLectureNotes from "./ViewLectureNotes";
import { useParams } from "react-router-dom";
import { useGetBatchDurationDaysQuery  } from "src/services/BatchServices";
import { CircularProgress } from "@mui/material";

const ViewLectureNotesWrapper = () => {
  const [calenadarData, setCalendarData] = useState<any>([]);
  const { batchId } = useParams();


  const { data, isLoading, isFetching } = useGetBatchDurationDaysQuery({
    limit: 20,
    searchValue: "",
    params: ["_id", "dayWisePlanning.date"],
    page: 0,
    filterBy: [
      {
        fieldName: "_id",
        value: [batchId],
      },
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });
  useEffect(() => {
    setCalendarData(data?.data?.[0]?.dayWisePlanning);
  }, [isLoading, isFetching, data]);

  return (
    <>
      {(isLoading || isFetching) && (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}
      <ViewLectureNotes
    
        calenadarData={calenadarData}
        
      />
    </>
  );
};

export default ViewLectureNotesWrapper;
